import { render, staticRenderFns } from "./RecordingsByHole.vue?vue&type=template&id=5d20c8f0&scoped=true&"
import script from "./RecordingsByHole.vue?vue&type=script&lang=js&"
export * from "./RecordingsByHole.vue?vue&type=script&lang=js&"
import style0 from "./RecordingsByHole.vue?vue&type=style&index=0&id=5d20c8f0&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d20c8f0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VSimpleTable,VSkeletonLoader})
